/* Spanish catalog mirroring locale-closing-cash-fr.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'clo.cash.quickComments': 'Comentarios rápidos',
  'clo.cash.quickCountLabel': 'Contado por el director general',
  'clo.cash.quickCountText': 'El efectivo en caja se contó físicamente a 31 de diciembre de {{year}} por el director general.',
  'clo.cash.quickSheetLabel': 'Hoja de recuento guardada',
  'clo.cash.quickSheetText': 'La hoja de recuento firmada se revisó y se guardó con la documentación contable.',
  'clo.cash.quickReportLabel': 'Comparado con el informe de caja',
  'clo.cash.quickReportText': 'El recuento se comparó con el informe de caja a 31 de diciembre de {{year}}.',
  'clo.cash.openPosting': 'Crear asiento manual',
  'clo.cash.postingTitle': 'Corregir el efectivo en caja',
  'clo.cash.postingDescription': 'Corrección tras el arqueo de caja {{year}}',
  'clo.cash.postingLoadError': 'No se pudo cargar el asiento manual.',
  'clo.cash.postingSaved': 'El asiento se contabilizó. Revisa la diferencia de nuevo.',
});
